module.exports = __webpack_public_path__ + "static/media/edit-black.2de08358.svg";